import { BillingSchedule } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';

/**
 * 1350. 請求予定一覧
 * [GET] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/billing_schedules
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
  enabled?: boolean;
};

const billingSchedule = (props: Props): Promise<BillingSchedule[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.id}/billing_schedules`);
};

export const useBillingSchedules = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'teams', props.team_id, 'sales_orders', props.id, 'billing_schedules'],
    queryFn: () => billingSchedule(props),
    enabled: props.enabled,
  });
};

export const useBillingSchedulesInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ['workspaces', props.identifier, 'teams', props.team_id, 'sales_orders', props.id, 'billing_schedules'] });
  };

  return { invalidate };
};
